import { render, staticRenderFns } from "./Invoice-Payment-List.vue?vue&type=template&id=2f060bcb&scoped=true&"
import script from "./Invoice-Payment-List.vue?vue&type=script&lang=js&"
export * from "./Invoice-Payment-List.vue?vue&type=script&lang=js&"
import style0 from "./Invoice-Payment-List.vue?vue&type=style&index=0&id=2f060bcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f060bcb",
  null
  
)

export default component.exports